/* eslint-disable comma-dangle */
/* eslint-disable brace-style */
/**
 * @file
 * Brand Accordion component behaviors.
 *
 * @param {object} Drupal - The Drupal object.
 */

(function (Drupal) {
  'use strict';

  /**
   * Behavior for Brand Accordion component.
   *
   * @type {object}
   */
  Drupal.behaviors.brandAccordion = {
    attach: function (context, settings) {
      const accordionSelector = document.querySelector('.brand-accordion');
      accordionSelector.classList.add('brand-accordion--all-closed');
      // Helper function to close an accordion header
      function closeAccordion(header) {
        const icon = header.querySelector('.brand-accordion__icon');
        const content = header.nextElementSibling;

        header.classList.remove(
          'brand-accordion__header--initial',
          'brand-accordion__header--expanded',
          'brand-accordion__header--contracted'
        );
        header.classList.add('brand-accordion__header--contracted');
        header.setAttribute('aria-expanded', 'false');
        header.setAttribute('data-analytics-event', 'accordion_open');

        if (icon) {
          icon.classList.remove(
            'brand-accordion__icon--initial',
            'brand-accordion__icon--expanded',
            'brand-accordion__icon--contracted'
          );
          icon.classList.add('brand-accordion__icon--contracted');
        }

        if (content) {
          content.classList.remove('brand-accordion__content--active');
        }
      }

      once('brand-accordion', '.brand-accordion__header', context).forEach(
        function (header) {
          // Set initial state if not already set
          if (
            !header.classList.contains('brand-accordion__header--expanded') &&
            !header.classList.contains('brand-accordion__header--contracted')
          ) {
            header.classList.add('brand-accordion__header--initial');
            header.setAttribute('aria-expanded', 'false');
            header.setAttribute('data-analytics-event', 'accordion_open');
          }

          const allHeaders = document.querySelectorAll(
            '.brand-accordion__header'
          );

          const closeAll = () => {
            allHeaders.forEach(h => {
              if (
                h !== this &&
                (h.classList.contains('brand-accordion__header--expanded') ||
                  h.classList.contains('brand-accordion__header--initial'))
              ) {
                closeAccordion(h);
              }
            });
          };

          header.addEventListener('click', function () {
            const isInitial = this.classList.contains(
              'brand-accordion__header--initial'
            );
            const isExpanded = this.classList.contains(
              'brand-accordion__header--expanded'
            );

            // Close all other accordions if exclusive behavior is desired
            if (header.closest('[data-exclusive="true"]')) {
              closeAll();
            }

            // Get the icon and content elements
            const icon = this.querySelector('.brand-accordion__icon');
            const content = this.nextElementSibling;

            // Remove all state classes first
            this.classList.remove(
              'brand-accordion__header--initial',
              'brand-accordion__header--expanded',
              'brand-accordion__header--contracted'
            );

            if (icon) {
              icon.classList.remove(
                'brand-accordion__icon--initial',
                'brand-accordion__icon--expanded',
                'brand-accordion__icon--contracted'
              );
            }

            // Toggle between states
            if (isInitial) {
              // Initial → Expanded
              this.classList.add('brand-accordion__header--expanded');
              this.setAttribute('aria-expanded', 'true');
              this.setAttribute('data-analytics-event', 'accordion_close');
              accordionSelector.classList.remove('brand-accordion--all-closed');
              accordionSelector.classList.add('brand-accordion--expanded');
              if (icon) {
                icon.classList.add('brand-accordion__icon--expanded');
              }
              if (content) {
                content.classList.add('brand-accordion__content--active');
              }
            } else if (isExpanded) {
              // Expanded → Contracted
              this.classList.add('brand-accordion__header--contracted');
              this.setAttribute('aria-expanded', 'false');
              this.setAttribute('data-analytics-event', 'accordion_open');
              if (icon) {
                icon.classList.add('brand-accordion__icon--contracted');
              }
              if (content) {
                content.classList.remove('brand-accordion__content--active');
              }
              accordionSelector.classList.add('brand-accordion--all-closed');
              accordionSelector.classList.remove('brand-accordion--expanded');
            } else {
              // Contracted → Expanded
              this.classList.add('brand-accordion__header--expanded');
              this.setAttribute('aria-expanded', 'true');
              this.setAttribute('data-analytics-event', 'accordion_close');
              accordionSelector.classList.remove('brand-accordion--all-closed');
              accordionSelector.classList.add('brand-accordion--expanded');
              if (icon) {
                icon.classList.add('brand-accordion__icon--expanded');
              }
              if (content) {
                content.classList.add('brand-accordion__content--active');
              }
            }
          });
        }
      );
    },
  };
})(Drupal);
